/**
 * Value formatting kinds used when rendering report cells and totals.
 */
export enum ReportValueType {
  string = 'string',
  number = 'number',
  quantity = 'quantity',
  currency = 'currency',
  date = 'date',
  dateTime = 'dateTime',
}
